import InboxMigrationsAPI from '../../api/inboxMigrations';

const SET_UI_FLAG = 'SET_INBOX_MIGRATION_UI_FLAG';
const SET_LAST_MIGRATION = 'SET_LAST_INBOX_MIGRATION';

export const state = {
    uiFlags: {
        isMigrating: false,
    },
    lastMigration: null,
};

export const getters = {
    getUIFlags(_state) {
        return _state.uiFlags;
    },
    getLastMigration(_state) {
        return _state.lastMigration;
    },
};

export const actions = {
    async migrateInbox({ commit }, { sourceInboxId, targetInboxId }) {
        commit(SET_UI_FLAG, { isMigrating: true });

        try {
            const response = await InboxMigrationsAPI.migrate(sourceInboxId, targetInboxId);
            commit(SET_LAST_MIGRATION, response.data);
            return response.data;
        } catch (error) {
            throw error;
        } finally {
            commit(SET_UI_FLAG, { isMigrating: false });
        }
    },
};

export const mutations = {
    [SET_UI_FLAG](_state, uiFlags) {
        _state.uiFlags = {
            ..._state.uiFlags,
            ...uiFlags,
        };
    },
    [SET_LAST_MIGRATION](_state, payload) {
        _state.lastMigration = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};